/*
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ]
  }
  ```
*/
import React from 'react'
// import { NavBar } from '../components/NavBar'
import { Page } from '../components/Page'

export const Dashboard: React.FC = () => {
  return <Page title="Dashboard">Dashboard Content</Page>
}
